import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourJourney />
      <Footer />
    </div>;
}